









































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { ModelSync, Prop } from 'vue-property-decorator'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import QSelect from 'quasar/src/components/select/QSelect.js';

@Component({
  components: { BaseSelect, BaseInput }
})
export default class TagsInput extends Vue {
  @ModelSync('value', 'input', {
    type: Array,
    default() {
      return []
    }
  }) model!: string[]

  @Prop() label!:string

  inputValue: string = ''

  $refs: {
    tagsInput: QSelect
  }

  pushValue(event) {
    this.inputValue = event
  }

  addTag() {
    if (this.inputValue !== '') this.$refs.tagsInput.add(this.inputValue)
    this.inputValue = ''
  }

}
